module.exports = __webpack_public_path__ + "img/866-782cf2.png";